import {Sparkles} from 'lucide-react';
import {useIntl} from 'react-intl';
import {insightsMessages as m} from '../insightsMessages';
import {bodyText, lucide, tintButton} from '../insightsUi';
import {legacyBullets} from './summaryText';
import {isFinalError} from '../insightsErrors';
import {GenerationStatus, type GenerationState} from './GenerationStatus';

interface LegacySummaryProps {
    text: string | null | undefined;
    canUpgrade: boolean;
    generation: GenerationState;
    onUpgrade: () => void;
}

export const LegacySummary = ({text, canUpgrade, generation, onUpgrade}: LegacySummaryProps) => {
    const intl = useIntl();
    const bullets = legacyBullets(text);
    return (
        <div className="flex flex-col gap-6" data-testid="insights-legacy-summary">
            <ul className="m-0 flex list-disc flex-col gap-2 pl-5">
                {bullets.map((bullet, index) => <li key={index} className={`${bodyText} text-ink`}>{bullet}</li>)}
            </ul>
            {canUpgrade && (
                <div className="flex flex-col items-start gap-2 rounded-card bg-brand-tint-subtle p-4">
                    <p className="m-0 text-footnote text-ink-secondary">{intl.formatMessage(m.summaryUpgradeHint)}</p>
                    {generation.pending ? (
                        <GenerationStatus generation={generation}/>
                    ) : isFinalError(generation.error) ? null : (
                        <button type="button" onClick={onUpgrade} className={tintButton}>
                            <Sparkles size={14} aria-hidden="true" className={lucide}/>
                            {intl.formatMessage(generation.error ? m.tryAgain : m.summaryUpgrade)}
                        </button>
                    )}
                    {!generation.pending && generation.error ? <GenerationStatus generation={generation}/> : null}
                </div>
            )}
        </div>
    );
};
